import { useEffect, useState } from 'react'
import i18n from '@/utils/i18n'

function formatAgo(ms: number): string {
  const en = i18n.language === 'en'
  const s = Math.max(0, Math.floor(ms / 1000))
  if (s < 60) return en ? 'just now' : 'только что'
  const m = Math.floor(s / 60)
  if (m < 60) return en ? `${m} min ago` : `${m} мин назад`
  const h = Math.floor(m / 60)
  const restM = m - h * 60
  if (h < 24) {
    if (en) return restM > 0 ? `${h}h ${restM}m ago` : `${h}h ago`
    return restM > 0 ? `${h} ч ${restM} мин назад` : `${h} ч назад`
  }
  const d = Math.floor(h / 24)
  if (en) return `${d}d ago`
  return `${d} ${d === 1 ? 'день' : d < 5 ? 'дня' : 'дней'} назад`
}

/** «N мин назад», тикает раз в 30 сек. Header лида (Создан), палитра (взят, SMS). */
export function LiveAgo({ from, className }: { from: string | null | undefined; className?: string }) {
  const [, setT] = useState(0)
  useEffect(() => {
    if (!from) return
    const id = window.setInterval(() => setT((x) => x + 1), 30_000)
    return () => window.clearInterval(id)
  }, [from])
  if (!from) return null
  const ms = Date.now() - new Date(from).getTime()
  return <span className={className}>{formatAgo(ms)}</span>
}
